


























































































































import { Component, Mixins } from 'vue-property-decorator'

import MixinScroll from '@globalMixins/scroll'
import MixinGather from '@bizMixins/gather'
import MixinProvideProduct from '@bizMixins/Provide/product'

import { promoteSummary as promoteSummaryChannelConfig } from '@bizConf/channel'

import { ToggleLoadingKey } from '@/decorator'

import { transformObject } from '@bizUtils/product'
import { toDate } from '@globalUtils/date'
import { lineBreakToBrTag, urlToATag } from '@globalUtils/lib'
import Scroll from '@globalUtils/scroll'

import {
  getPromoteProduct,
  // getPromoteProductForSaleRank,
  getPromoteHistory,
  // getPromoteHistoryForSaleRank,
  getPromoteGuidesByHdk,
  getPromoteHistoryByHour,
  getPromoteHistoryByDay
} from '@/api/PromoteRecord'

import ModelGuide from '@bizCmp/model/Guide.vue'
import ModelGatherCoupon from '@bizCmp/model/gather/Coupon.vue'
import ModelGatherChannel from '@bizCmp/model/gather/Channel.vue'
import DatePicker from '@bizCmp/date-picker/Date.vue'

import Product from './components/product/Index.vue'
import ProductInfo from './components/product/Info.vue'
import PromoteSummary from './components/PromoteSummary.vue'
import PromoteChart from './components/PromoteChart.vue'
import HistoryData from './components/HistoryData.vue'

import HoursRecord from './components/HoursRecord/Index.vue'
import DayRecord from './components/DayRecord/Index.vue'

import { datetime } from '@/filter/global/date'

const scroll = new Scroll()

const saleTabsIndexToListField = {
  0: 'amount',
  1: 'increment'
}

const sortDirection = {
  down: -1,
  up: 1
}

Object.freeze(saleTabsIndexToListField)
Object.freeze(sortDirection)

@Component({
  components: {
    PromoteSummary,
    PromoteChart,
    ModelGuide,
    ModelGatherCoupon,
    ModelGatherChannel,
    Product,
    ProductInfo,
    DatePicker,
    HistoryData,
    HoursRecord,
    DayRecord
  }
})
export default class PromoteRecord extends Mixins(
  MixinScroll,
  MixinGather,
  MixinProvideProduct
) {
  loadingHistory = true
  loadingTime = true

  saleTabs = ['总量', '增量']
  saleTabsActiveIndex = 0

  timeTabs = [
    {
      name: '按小时查看',
      component: 'HoursRecord',
      data: [] as {}[],
      positionIndex: '',
      page: 1,
      api: getPromoteHistoryByHour,
      transformApiData: (list: {}[]) => {
        return list.map((item: {}) => {
          const badgePlatforms: {}[] = []

          if (item['rank']) {
            Object.keys(item['rank'])

            item['rank']['haodanku'] === 1 &&
              badgePlatforms.push({ type: 'hdk' })

            item['rank']['dataoke'] === 1 &&
              badgePlatforms.push({ type: 'dtk' })
          }

          return {
            badgePlatforms,

            ...this.timeTabCommonField(item),

            channelQuantity: item['channels'],
            todaySale: item['daysale'],
            postCouponPrice: item['final_price'],
            commissionRate: item['commission_rate'],
            commission: item['commission_value'],
            coupon: item['coupon_price'],
            list: item['sub_list'].map((subItem: {}) => {
              return {
                date: subItem['time'],
                amount: subItem['monthsale'],
                increment: subItem['increment'],
                channels: Object.keys(subItem['channelInfo'])
                  .filter((key: string) => subItem['channelInfo'][key] > 0)
                  .map((key: string) => ({
                    type: key,
                    quantity: subItem['channelInfo'][key]
                  }))
              }
            })
          }
        })
      }
    },
    {
      name: '按天查看',
      component: 'DayRecord',
      data: [] as {}[],
      positionIndex: '',
      page: 1,
      api: getPromoteHistoryByDay,
      transformApiData: (list: {}[]) => {
        return list.map((item: {}) => {
          return {
            ...this.timeTabCommonField(item),

            postCouponPrice: item['promotion_plan']['final_price'],
            commissionRate: item['promotion_plan']['rate'],
            commission: item['promotion_plan']['commission_value'],
            coupon: item['promotion_plan']['coupon_value'],
            amount: item['monthsale'],
            increment: item['daysale'],
            channels: Object.keys(item['channal_info'])
              .filter((key: string) => item['channal_info'][key] > 0)
              .map((key: string) => {
                return {
                  type: key,
                  quantity: item['channal_info'][key]
                }
              })
          }
        })
      }
    }
  ]
  timeTabsActiveIndex = 0

  summaryChannels: {}[] = []

  collapseList = false

  date = {}
  dateSelected!: any
  currentDate!: Date

  showModelGuide = false

  modelGuideCarousel = true
  modelGuideCustom = true

  guides: {}[] = []

  summaries: {}[] = [
    {
      name: '最高券后价',
      quantity: 0,
      filter: 'price'
    },
    {
      name: '最低券后价',
      quantity: 0,
      filter: 'price'
    },
    {
      name: '最大券额',
      quantity: 0,
      filter: 'price'
    },
    {
      name: '最高佣金比例',
      quantity: 0,
      filter: 'percent'
    },
    {
      name: '优惠券数',
      quantity: 0,
      filter: 'tenThousandW',
      emitName: 'coupon',
      textUnderline: true
    }
  ]

  promotes: {}[] = []

  productId: any
  activityId: any

  scrollBottom = false
  horizontalScrollbar = false

  // get isSingleDay() {
  //   return this.date['selected'][0] === this.date['selected'][1]
  // }

  get charts() {
    return this.promotes
      .map((item: {}): [string, number] => {
        return [
          item['time'],
          item[saleTabsIndexToListField[this.saleTabsActiveIndex]]
        ]
      })
      .reverse()
  }

  get activeTimeTab() {
    return this.timeTabs[this.timeTabsActiveIndex]
  }

  get datetimeParam() {
    return {
      start_time: this.date['selected'][0],
      end_time: this.date['selected'][1]
    }
  }

  created() {
    this.handleRouteQuery()

    this.getPromoteProduct()
    this.getActiveTimeTabData()
  }

  hasScrollHeight() {
    this.scrollBottom = scroll.isScrollBottom(88)
    this.horizontalScrollbar = scroll.hasScrollH()

    return scroll.getAttrVal('scrollHeight') > 1220
  }

  handleRouteQuery() {
    const {
      product_id: productId,
      activity_id: activityId,
      date
    } = this.$route.query

    this.productId = productId
    this.activityId = activityId

    if (date) {
      this.dateSelected = date
    }
  }

  timeTabCommonField(item: {}) {
    const guides: {}[] = []

    if (item['content']) {
      guides.push(
        this.generatePromotionGuide(
          item['time'],
          item['pics'],
          urlToATag(lineBreakToBrTag(item['content']))
        )
      )
    }

    return {
      time: item['time'],
      date: item['time'] + ' ' + item['week'],
      hadGuide: Boolean(item['content']),
      guides
    }
  }

  handleProductCoupon(startTime = toDate(this.currentDate)) {
    const datetimeParam = {
      start_time: startTime,
      end_time: startTime
    }

    this.openGatherCoupon(this.productId, datetimeParam)
  }

  handleCoupon() {
    this.openGatherCoupon(this.productId, this.datetimeParam)
  }

  getPromoteProductApi() {
    // let api: Function
    // let params: {}
    // if (this.activityId) {
    const api = getPromoteProduct
    const params = {
      activity_id: this.activityId
    }
    // } else {
    //   api = getPromoteProductForSaleRank
    //   params = {}
    // }

    return { api, params }
  }

  async getPromoteProduct() {
    const { api, params } = this.getPromoteProductApi()
    const data = await api({
      product_id: this.productId,
      ...params
    })

    if (!data) {
      return
    }

    const { product, channelInfo, sale, seller, timestamp } = data

    Object.assign(product, sale)
    const currentProduct = transformObject(product, sale, {
      platform: product['platform']
    })

    currentProduct['shopScores'] = seller
    currentProduct['channels'] = channelInfo

    this.provide.product = currentProduct
    this.currentDate = new Date(timestamp * 1000)

    if (!this.dateSelected) {
      // 默认选中近30天，由于当天不算一天，所以要少一天
      this.dateSelected = toDate(
        new Date((timestamp - 60 * 60 * 24 * (30 - 1)) * 1000)
      )
    }
  }

  getPromoteHistory() {
    // let api: Function
    // let params: {}

    // if (this.activityId) {
    const api = getPromoteHistory
    const params = {
      activity_id: this.activityId
    }
    // } else {
    //   api = getPromoteHistoryForSaleRank
    //   params = {}
    // }

    this.reallyGetPromoteHistory(api, params)
  }

  getPromoteParamTodayByHDK(day: string) {
    return day.replace(/-/g, '')
  }

  generatePromotionPlanByHDK(planItem: {}) {
    return {
      originalPirce: planItem['itemprice'] * 100 || '',
      postCouponPrice: planItem['itemendprice'] * 100 || '',
      coupon: planItem['couponmoney'] * 100 || '',
      commissionRate: planItem['tkrates'],
      commission: planItem['itemendprice'] * planItem['tkrates'] || ''
    }
  }

  generatePromotionGuidesByHDK(list: {}[], time: string) {
    return list.map((item: {}) => this.generatePromotionGuideByHDK(item, time))
  }

  generatePromotionGuideByHDK(item: {}, time: string) {
    return this.generatePromotionGuide(
      time,
      item['itempic'],
      this.generateGuideCopywritingByHDK(item)
    )
  }

  generatePromotionGuide(
    time: string,
    marketingImg: string,
    guideCopywriting: string
  ) {
    return {
      time,
      marketingImg,
      guideCopywriting
    }
  }

  generateGuideCopywritingByHDK(item: {}) {
    const productUrl =
      `https://detail.tmall.com/item.htm?id=${this.productId}` || ''
    const couponUrl = item['couponurl'] || ''
    const originPrice = item['itemprice'] || ''
    const postCouponPrice = item['itemendprice'] || ''

    return `
            ${item['short_itemdesc'] || ''}<br />
            原价：￥${originPrice}&nbsp;&nbsp;券后价：￥${postCouponPrice}<br />
            领劵：<a href="${couponUrl}" target="_blank">${couponUrl}</a><br />
            抢购：<a href="${productUrl}" target="_blank">${productUrl}</a><br />
            ${item['guide_article'] || ''}
          `
  }

  async handlePromoteHistory(summary: {}, list: {}[]) {
    const listLastIndex = list.length - 1

    this.summaries[0]['quantity'] = summary['max_final_price'] || ''
    this.summaries[1]['quantity'] = summary['min_final_price'] || ''
    this.summaries[2]['quantity'] = summary['max_coupon_value'] || ''
    this.summaries[3]['quantity'] = summary['max_rate'] || ''
    this.summaries[4]['quantity'] = summary['coupon_number'] || ''

    this.promotes = list
      .map((item: {}, index: number) => {
        return {
          time: item['time'],
          promotionPlans: (item['promotion_plan'] || []).map(
            (planItem: {}, i: number) => {
              return {
                originalPirce: planItem['price'],
                postCouponPrice: planItem['final_price'],
                coupon: planItem['coupon_value'],
                commissionRate: planItem['rate'],
                commission: planItem['commission_value']
              }
            }
          ),
          increment:
            index === listLastIndex
              ? 0
              : item['amount'] - list[index + 1]['amount'],
          amount: item['amount'],
          channels: item['channal_info']
        }
      })
      .filter(
        (item: {}) => item['promotionPlans'].length > 0 || item['amount'] > 0
      )
  }

  @ToggleLoadingKey('loadingHistory')
  async reallyGetPromoteHistory(api: Function, params = {}) {
    const data = await api(
      {
        product_id: this.productId,
        ...this.datetimeParam,
        ...params
      },
      {
        loading: {
          className: 'g-po-top'
        }
      }
    )

    if (!data) {
      this.resetPromoteHistory()
      return
    }

    const { summary, channelInfo, list } = data
    await this.handlePromoteHistory(summary, list)
    this.summaryChannels = channelInfo.map((channel: {}) => {
      channel['name'] = promoteSummaryChannelConfig[channel['type']]

      return channel
    })
  }

  resetPromoteHistory() {
    if (this.summaryChannels.length === 0) {
      this.summaryChannels = Object.keys(promoteSummaryChannelConfig).map(
        (key: string) => {
          return {
            type: key,
            name: promoteSummaryChannelConfig[key],
            quantity: 0
          }
        }
      )
    } else {
      this.summaryChannels.forEach((channel: {}) => {
        if (channel['quantity'] !== 0) {
          channel['quantity'] = 0
        }
      })
    }

    this.summaries.forEach((summary: {}) => (summary['quantity'] = 0))

    this.promotes = []
  }

  handelOpenGatherChannelsOfHours(item: {}, param: {}) {
    this.openGatherChannels(item, this.productId, {
      start_time: param['time'],
      end_time: param['time'].slice(0, -2) + '59'
    })
  }

  handelOpenGatherChannelsBySingleDay(item: {}, param: {}) {
    this.openGatherChannels(item, this.productId, {
      start_time: param['time'],
      end_time: param['time']
    })
  }

  handelOpenGatherChannels(item: {}, other = {}) {
    let option
    if (other['time']) {
      option = {
        start_time: other['time'],
        end_time:
          this.timeTabsActiveIndex === 0
            ? this.minutesTest(other['time'])
            : other['time']
      }
    } else if (other['timeOfDay']) {
      option = {
        start_time: other['timeOfDay'],
        end_time: other['timeOfDay']
      }
    } else {
      option = this.datetimeParam
    }

    this.openGatherChannels(item, this.productId, {
      ...option,
      ...other
    })
  }

  minutesTest(val: Date) {
    const date = new Date(
      new Date(val).setMinutes(new Date(val).getMinutes() + 30)
    )
    return datetime(new Date(date))
  }

  handelOpenGatherHistory(other = {}) {
    this.openGatherChannels({}, this.productId, other)
  }

  handelOpenGatherChannelsOfProduct(item: {}) {
    this.openGatherChannels(item, this.productId, {
      day: 1
    })
  }
  async handleGuide(item: {}, startDate: string, endDate = startDate) {
    this.openModelGuide()

    this.guides = item['guides'] || []
  }

  openModelGuide(): void {
    this.showModelGuide = true
  }

  closeModelGuide(): void {
    this.showModelGuide = false
  }

  changeSaleTabs(index: number): void {
    this.saleTabsActiveIndex = index
  }

  async handleTimeTabDataNoGuide(list: {}[]) {
    const noGuides: {}[] = []

    list.forEach((item: {}, index: number) => {
      if (!item['hadGuide']) {
        noGuides.push({
          date: this.getPromoteParamTodayByHDK(item['time']),
          index
        })
      }
    })

    if (noGuides.length > 0) {
      const data = await getPromoteGuidesByHdk({
        itemid: this.productId,
        today: noGuides.map((item: {}) => item['date']).join(',')
      })

      noGuides.forEach((item: {}) => {
        const guides = data[item['date']]
        if (guides && guides.length > 0) {
          const listitem = list[item['index']]

          listitem['guides'] = this.generatePromotionGuidesByHDK(
            guides,
            item['time']
          )
          listitem['hadGuide'] = true
        }
      })
    }
  }

  @ToggleLoadingKey('loadingTime')
  async getActiveTimeTabData(other = {}) {
    const page = this.activeTimeTab.page
    const param = {
      product_id: this.productId,
      page
    }

    if (page > 1) {
      param['position_index'] = this.activeTimeTab.positionIndex
    }

    const data = await this.activeTimeTab.api(param, other)

    const list = this.activeTimeTab.transformApiData(data['list'] || [])

    await this.handleTimeTabDataNoGuide(list)

    this.activeTimeTab.data = (page > 1 ? this.activeTimeTab.data : []).concat(
      list
    )

    this.activeTimeTab.positionIndex = data['position_index']
  }

  nextPage(ref: HTMLElement) {
    this.activeTimeTab.page++

    scroll.request(
      this.getActiveTimeTabData.bind({
        loading: {
          mountDom: ref
        }
      })
    )
  }

  changeTimeTabs(index: number) {
    this.timeTabsActiveIndex = index
    if (
      this.activeTimeTab.data.length === 0 &&
      this.activeTimeTab.positionIndex === ''
    ) {
      this.getActiveTimeTabData()
    }
  }

  toggleList(): void {
    this.collapseList = !this.collapseList
  }

  // resetTimeTabsData() {
  //   this.timeTabs.forEach((timeTab: {}) => {
  //     timeTab['positionIndex'] = ''
  //     timeTab['data'] = []
  //   })
  // }

  dateChange(date: {}): void {
    this.date = date

    this.getPromoteHistory()

    // this.resetTimeTabsData()

    // this.getActiveTimeTabData()
  }
}
